export default __webpack_public_path__ + "static/media/logo2.c2b97b52.png";